var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuvFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#009543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v22.5H0V0Z",
    fill: "#D21034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 28 18.474h32v8.052H28L0 45",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m-2.407 3.648 4.814-7.296 26.905 17.75H64.37v16.795H29.31L2.408 48.65l-4.814-7.297L26.165 22.5-2.406 3.648Z",
    fill: "#FDCE12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m-1.313 1.99 2.626-3.98 27.403 18.08H60v4.768H27.284L-1.313 1.99Zm28.597 22.152H60v4.768H28.716L1.313 46.99l-2.626-3.98 28.597-18.868Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.065 26.81v2.559c2.226 0 6.603-1.706 6.603-7.21s-4.67-6.527-6.063-6.527c-1.402 0-5.713 1.004-5.713 5.495 0 4.51 4.235 4.926 5.069 4.926.833 0 3.96-.758 3.6-4.13a3.363 3.363 0 0 1-3.354 2.984c-2.274 0-3.695-1.687-3.695-3.354 0-1.668 1.383-3.903 3.78-3.903s4.15 2.131 4.15 4.272c0 2.15-1.687 4.88-4.377 4.88v.009Z",
    fill: "#FDCE12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.104 23.467.132.095s1.061-2.416 3.894-4.13c-.36.189-2.255 1.136-4.026 4.035Z",
    fill: "#FDCE12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.086 19.411.026-.014.038.066a10.754 10.754 0 0 0-2.999 2.7 9.311 9.311 0 0 0-.672 1.013 6.184 6.184 0 0 0-.205.394l-.002.005v.001H6.27l-.019.043-.17-.121.022-.031-.033-.02c1.738-2.843 3.595-3.816 4.015-4.036Zm-3.932 4.045.067.048.032-.067c.035-.07.088-.171.16-.298a9.39 9.39 0 0 1 .828-1.216c-.358.436-.725.944-1.087 1.534Z",
    fill: "#FDCE12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.378 23.05s-.322-.663-.038-.966c.285-.294.161.786.161.786l.124-.18s-.19-.815.018-.985c.218-.18.114.786.114.786l.133-.17s-.142-.796.066-.948c.218-.152.085.758.085.758l.152-.19s-.114-.757.142-.937c.256-.18.028.72.028.72l.171-.19s-.076-.691.142-.852c.218-.152.038.663.038.663l.152-.17s-.048-.645.16-.797c.219-.151.02.616.02.616l.16-.151s-.037-.654.228-.777-.047.606-.047.606l.19-.152s.046-.757.274-.824c.227-.076-.095.663-.095.663l.161-.132s.085-.644.332-.72c.256-.085-.152.587-.152.587l.161-.123s.18-.644.417-.72c.227-.066-.246.616-.246.616l.16-.114s.257-.587.474-.625c.2-.038-.246.483-.246.483l.2-.114s.33-.606.454-.426c.114.19-.474.464-.474.464l-.19.114s.711-.341.796-.17c.086.17-.975.284-.975.284l-.17.113s.71-.19.624-.01c-.094.18-.795.143-.795.143l-.161.114s.71-.171.615 0c-.094.151-.786.142-.786.142l-.17.142s.691-.19.587.028c-.095.209-.89.2-.89.2l-.19.189s.73-.256.663-.057c-.057.19-.89.284-.89.284l-.19.19s.786-.256.55-.02c-.228.247-.806.304-.806.304l-.218.284s.777-.474.664-.209c-.105.266-.872.446-.872.446l-.152.19s.701-.408.626-.19c-.067.237-.815.473-.815.473l-.123.171s.824-.493.758-.237c-.076.246-.862.426-.862.426l-.095.162s.758-.446.758-.228c.019.209-.89.417-.89.417l-.02-.18Z",
    fill: "#FDCE12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuvFlag);
export default __webpack_public_path__ + "static/media/vuv-flag.d111320dbc4ae2bb34561250591c42db.svg";
export { ForwardRef as ReactComponent };